module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABGUlEQVQ4ja2UPW4CMRBG36JAkzNQhSJU5DKJlIaCNKFFKAUFB8gFcgeugGgixAlSUsEZaEiEoyGzKzAzNpH2k0Za+ef5yfa6CI+kUgDvwFDHfABvQKjmzMLZ9EYSBy/AGLjVGmubmxSwBUyN9qn2mUkBB0DbaG9r37+AYjBJLDbxLD1gbLfRylpawNhuDtxpzXOWFjC2WwA/WoucZQy09q7rfP9ZPhVnljHQOtme821anv4pstLaAH7rpZbsgGbUvwU6zMI+NvTunQDutWLYhWUJzN27By0v1V6WQM+uzLOWl8qycYWd5EsrlaOlHMqrPkupnB5KKsMbYJQZJPm8YoxkJIYHfUjrSJA9XNYEkywF2AdWNcBWQP8XM2I0IKR0ot4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/alarmList/list_icon_police.png
// module id = a+W5
// module chunks = 1